@if (
  {
    cat: taskCategory | async,
  };
  as $
) {
  @if ($.cat) {
    <span>{{ $.cat?.name_primary_language }}</span>
  } @else {
    -
  }
}
